import React, { useEffect, useState } from "react";

import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  Paper,
  Stack,
  TextField,
} from "@mui/material";

import {
  DatePicker,
  LocalizationProvider,
  TimePicker,
} from "@mui/x-date-pickers";

import { Encabezado } from "../../../Components/Encabezado/Encabezado";
import { Controller, useForm, useWatch } from "react-hook-form";
import { isAfter, isEqual, startOfDay } from "date-fns";
import { useDispatch, useSelector } from "react-redux";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DataGrid } from "@mui/x-data-grid";

import Select from "react-select";
import moment from "moment";
import swal from "sweetalert";
import dayjs from "dayjs";
import SaveIcon from "@mui/icons-material/Save";

import {
  fetchAreasOrganizacionales,
  selectAllAreasOrganizacionales,
} from "../../../redux/AreaOrganizacional/AreaOrganizacionalSlice";

import {
  fetchTiposPermisos,
  fetchTiposPermisosCategorias,
  savePermisoArea,
  selectAllTiposPermisos,
  selectAllTiposPermisosCategorias,
  selectIsLoading,
  selectMessage,
  selectIsSuccess,
} from "../../../redux/Permisos/PermisosSlice";

import { fetchCambiarSuccess } from "../../../redux/Login/LoginSlice";

import {
  fetchEmpleados,
  selectAllEmpleados,
} from "../../../redux/Empleados/EmpleadosSlice";

import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import Loading from "../../../Components/Modals/Loading/Loader";
import { calcularDiasHabiles } from "../../../utils/funcionesFechasPermisos";
import {
  fetchListDiasFeriadosAnoActual,
  selectDiasFeriadosAnoActual,
} from "../../../redux/DiasFeriados/DiasFeriadosSlice";

export const DigitarPermisoArea = () => {
  // * FORMATO DE LA ESTRUCTURA DEL OBJETO.
  const formSchema = Yup.object().shape({
    areaId: Yup.number()
      .required("El campo es requerido")
      .notOneOf([0], "Debe seleccionar una opción válida"),
    tipoPermisoId: Yup.number()
      .required("El campo es requerido")
      .notOneOf([0], "Debe seleccionar una opción válida"),
    dias: Yup.number(),
    fechaInicio: Yup.date().required("El campo es requerido"),
    fechaTermino: Yup.date().required("El campo es requerido"),
    horaInicio: Yup.date().required("El campo es requerido"),
    horaTermino: Yup.date().required("El campo es requerido"),
    recurrencia: Yup.object().shape({
      recurrente: Yup.bool(),
      l: Yup.bool(),
      m: Yup.bool(),
      x: Yup.bool(),
      j: Yup.bool(),
      v: Yup.bool(),
      s: Yup.bool(),
      d: Yup.bool(),
    }),
    diaCompleto: Yup.bool(),
    justificacion: Yup.string(),
    empleados: Yup.array().min(1, "Debe seleccionar al menos un empleado."),
  });

  // * FECHA ACTUAL
  const date = new Date();

  // * FUNCIONES PARA RETORNAR FECHAS ASIGNADAS.
  const defaultHoraInicio = moment(
    new Date(date.getFullYear(), date.getMonth(), date.getDate(), 8, 0, 0, 0),
  ).format("YYYY-MM-DD HH:mm:ss");

  const defaultHoraTermino = moment(
    new Date(date.getFullYear(), date.getMonth(), date.getDate(), 16, 0, 0, 0),
  ).format("YYYY-MM-DD HH:mm:ss");

  // ? USE-FORM
  const {
    formState: { errors },
    register,
    handleSubmit,
    reset,
    setValue,
    watch,
    control,
  } = useForm({
    defaultValues: {
      areaId: 0,
      tipoPermisoId: 0,
      dias: 0,
      fechaInicio: date,
      fechaTermino: date,
      horaInicio: defaultHoraInicio,
      horaTermino: defaultHoraTermino,
      recurrencia: {
        recurrente: false,
        l: false,
        m: false,
        x: false,
        j: false,
        v: false,
        s: false,
        d: false,
      },
      diaCompleto: false,
      justificacion: "",
      empleados: [],
    },
    resolver: yupResolver(formSchema),
  });

  // ? HOOK-WATCH
  const permiso = useWatch({
    control,
  });

  // ? HOOK-WATCH
  const fechaInicio = useWatch({
    control,
    name: "fechaInicio",
  });

  const fechaTermino = useWatch({
    control,
    name: "fechaTermino",
  });

  const tipoPermisoId = useWatch({
    control,
    name: "tipoPermisoId",
  });

  const horaInicio = useWatch({
    control,
    name: "horaInicio",
  });

  const horaTermino = useWatch({
    control,
    name: "horaTermino",
  });

  // ? HOOK-WATCH CHECKED-RECURRENTE
  const checkedRecurrente = useWatch({
    control,
    name: "recurrencia.recurrente",
  });

  // ? HOOK-DISPATCH
  const dispatch = useDispatch();

  // ? HOOK SELECTOR
  const isLoading = useSelector(selectIsLoading);
  const message = useSelector(selectMessage);
  const isSuccess = useSelector(selectIsSuccess);
  const areaOrganizacionales = useSelector(selectAllAreasOrganizacionales);

  // ? HOOK-STATE
  const [tiposPermisosCategoriaGrupo, setTiposPermisosCategoriaGrupo] =
    useState([]);
  const [listaAreasState, setListaAreasState] = useState([]);
  const [listaEmpleadosState, setListaEmpleadosState] = useState([]);
  const tipospermisos = useSelector(selectAllTiposPermisos);
  const tipospermisosCategoria = useSelector(selectAllTiposPermisosCategorias);
  const empleadosList = useSelector(selectAllEmpleados);
  const diasFeriados = useSelector(selectDiasFeriadosAnoActual);

  // * FUNCION PARA REFRESCAR LA VALIDACION DE LA FIRMA DEL EMPLEADO
  const refreshSuccess = () => dispatch(fetchCambiarSuccess());

  // ? HOOK-EFFECT PARA REFRESCAR LISTAS.
  useEffect(() => {
    dispatch(fetchTiposPermisos());
    dispatch(fetchTiposPermisosCategorias());
    dispatch(fetchAreasOrganizacionales());
    dispatch(fetchListDiasFeriadosAnoActual());
  }, []);

  useEffect(() => {
    setListaAreasState([
      { id: 0, nombre: "Seleccionar Área" },
      ...areaOrganizacionales,
    ]);
  }, [areaOrganizacionales]);

  // ? HOOK-EFFECT PARA MOSTRAR LOS MENSAJES Y RESETEAR LOS INPUTS.
  useEffect(() => {
    if (isSuccess === "success" && message.length > 0) {
      swal("Exitoso!", message, "success");
      refreshSuccess();
      reset();
    } else if (isSuccess === "error" && message.length > 0) {
      swal("Error", message, "error");
      refreshSuccess();
    }
  }, [isSuccess]);

  // ? HOOK-EFFECT PARA RESTABLECER LOS CHECKBOX DE RECURRENCIA.
  useEffect(() => {
    if (!checkedRecurrente) {
      setValue("recurrencia.l", false);
      setValue("recurrencia.m", false);
      setValue("recurrencia.x", false);
      setValue("recurrencia.j", false);
      setValue("recurrencia.v", false);
      setValue("recurrencia.s", false);
      setValue("recurrencia.d", false);
    }
  }, [checkedRecurrente]);

  // ? HOOK-EFECT PARA SOLICITAR LOS DATOS A LA API.
  useEffect(() => {
    if (permiso.areaId === 0) {
      setListaEmpleadosState([]);
      return;
    }

    let dataSolicitar = {
      skipRow: 0,
      rowsPerPage: 0,
      areaOrganizacionalId: permiso.areaId,
      empleado: "",
      estado: 1,
    };

    dispatch(fetchEmpleados(dataSolicitar));
  }, [permiso.areaId]);

  useEffect(() => {
    setListaEmpleadosState(empleadosList);
  }, [empleadosList]);

  // ? CREACION DE LISTA PARA ORDENAR LOS PERMISOS SEGUN LA CATEGORIA.
  useEffect(() => {
    let tiposPermisosCategoriaOrder = [];
    if (tipospermisosCategoria && tipospermisosCategoria.length > 0) {
      tipospermisosCategoria.forEach((element) => {
        let arrayTipoPermiso = tipospermisos.filter(
          (x) => x.categoriaId === element.id,
        );
        let categoria = {
          label: element.nombre,
          options: arrayTipoPermiso.map((x) => ({
            label: x.nombre,
            value: x.id,
          })),
        };
        tiposPermisosCategoriaOrder.push(categoria);
      });
      setTiposPermisosCategoriaGrupo(tiposPermisosCategoriaOrder);
    }
  }, [tipospermisosCategoria, tipospermisos]);

  // ? HOOK-EFFECT PARA CALCULAR LOS DIAS DE DURACION DE PERMISO SEGUN LAS FECHAS.
  useEffect(() => {
    setValue(
      "dias",
      calcularDiasHabiles({
        fechaInicio,
        fechaTermino,
        diasFeriados,
        horaInicio,
        horaTermino,
        tipoPermisoId,
        setValue,
      }),
    );
  }, [fechaInicio, fechaTermino, tipoPermisoId, horaInicio, horaTermino]);

  // * ENVIAR DATA A API.
  const onSubmit = (data) => {
    if (!data) {
      return;
    }

    const dataForm = data;

    // * BORRANDO CAMPO INNECESARIO.
    delete dataForm.areaId;

    dispatch(savePermisoArea(dataForm));
  };

  const columns = [
    { field: "nombres", headerName: "Nombre", width: 300 },
    { field: "apellidos", headerName: "Apellido", width: 300 },
  ];

  const paginationModel = { page: 0, pageSize: 5 };

  return (
    <Encabezado title="Solicitar Permisos por Área">
      <Stack display="flex" alignItems="center">
        <Stack width="80%">
          <Paper elevation={5}>
            <Stack p={2}>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="container">
                  <div className="row">
                    <div className="form-group">
                      <label className="fw-bold">Área Organizacional</label>

                      <Controller
                        control={control}
                        name="areaId"
                        rules={{
                          required: "El campo es requerido",
                          validate: (value) =>
                            value !== 0 || "El campo es requerido",
                        }}
                        render={({ field }) => (
                          <Select
                            id="select-empleado"
                            classNamePrefix="select"
                            isSearchable={true}
                            placeholder="Seleccionar Área"
                            options={listaAreasState}
                            getOptionLabel={(option) => option.nombre}
                            getOptionValue={(option) => option.id}
                            onChange={(e) => field.onChange(e.id)}
                            value={listaAreasState.find(
                              (x) => x.id === field.value,
                            )}
                          />
                        )}
                      />

                      <p className="text-danger mb-0">
                        {errors?.areaId?.message}
                      </p>
                    </div>

                    <div className="form-group">
                      <div className="mt-3">
                        <DataGrid
                          autoHeight
                          rows={listaEmpleadosState}
                          columns={columns}
                          initialState={{ pagination: { paginationModel } }}
                          pageSizeOptions={[5, 10]}
                          checkboxSelection
                          onRowSelectionModelChange={(ids) => {
                            setValue("empleados", ids);
                          }}
                        />
                        <p className="text-danger mb-0">
                          {errors?.empleados?.message}
                        </p>
                      </div>
                    </div>
                    <div className="form-group mt-2">
                      <label className="fw-bold">Tipo Permiso</label>

                      <Controller
                        control={control}
                        name="tipoPermisoId"
                        rules={{
                          required: "El tipo de permiso es requerido",
                          validate: (value) =>
                            value !== 0 || "El permiso es requerido",
                        }}
                        render={({ field }) => (
                          <Select
                            classNamePrefix="select"
                            isSearchable={true}
                            placeholder="Seleccionar Tipo Permiso"
                            options={tiposPermisosCategoriaGrupo}
                            onChange={(e) => field.onChange(e.value)}
                            defaultValue={field.value}
                          />
                        )}
                      />
                      <p className="text-danger mb-0">
                        {errors?.tipoPermisoId?.message}
                      </p>
                    </div>
                    <div className="form-group">
                      <label className="fw-bold">Dias</label>
                      <input
                        type="number"
                        disabled
                        className="form-control"
                        value={watch("dias")}
                      />

                      <p className="text-danger mb-0">
                        {errors?.dias?.message}
                      </p>
                    </div>

                    {/* <div className="row mb-2 mt-2" hidden={tipoPermisoId !== 2}>
                        <div className="col">
                        <label style={{fontSize: 14}}><b>Años trabajados:</b> {vacacionesInfoState?.cantidadAñosTrabajados}</label>
                        </div>
                        <div className="col">
                        <label style={{fontSize: 14}}><b>Cantidad de días:</b> {vacacionesInfoState?.cantidadDiasVacacionesPorAñoTrabajado}</label>
                        </div>
                    </div> */}

                    <div className="row">
                      <div className="col">
                        <div className="form-group">
                          <label className="fw-bold">Fecha inicio</label>
                          <Controller
                            control={control}
                            name="fechaInicio"
                            rules={{
                              required: "La fecha de inicio es requerida",
                            }}
                            render={({ field }) => (
                              <LocalizationProvider
                                dateAdapter={AdapterDateFns}
                              >
                                <DatePicker
                                  inputFormat="dd/MM/yyyy"
                                  label={" "}
                                  mask="__/__/____"
                                  value={field.value}
                                  onChange={(e) => field.onChange(e)}
                                  renderInput={(params) => (
                                    <TextField
                                      height={10}
                                      className="form-control"
                                      style={{ height: 10 }}
                                      {...params}
                                    />
                                  )}
                                />
                              </LocalizationProvider>
                            )}
                          />
                          <p className="text-danger mt-3 mb-0">
                            {errors?.fechaInicio?.message}
                          </p>
                        </div>
                      </div>
                      <div className="col">
                        <div className="form-group">
                          <label className="fw-bold">Fecha Término</label>
                          <Controller
                            control={control}
                            name="fechaTermino"
                            rules={{
                              required: "La fecha de término es requerida",
                              validate: (value) => {
                                const fechaTermino = startOfDay(
                                  new Date(value),
                                );
                                const fechaInicioAjustada = startOfDay(
                                  new Date(permiso.fechaInicio),
                                );
                                return (
                                  isAfter(fechaTermino, fechaInicioAjustada) ||
                                  isEqual(fechaTermino, fechaInicioAjustada) ||
                                  "La fecha de término debe ser mayor o igual a la fecha de inicio"
                                );
                              },
                            }}
                            render={({ field }) => (
                              <LocalizationProvider
                                dateAdapter={AdapterDateFns}
                              >
                                <DatePicker
                                  minDate={
                                    startOfDay(new Date(permiso.fechaInicio)) -
                                    1
                                  }
                                  inputFormat="dd/MM/yyyy"
                                  label={" "}
                                  mask="__/__/____"
                                  value={
                                    field.value
                                      ? startOfDay(new Date(field.value))
                                      : null
                                  }
                                  onChange={(date) => {
                                    // Ajustar siempre al inicio del día
                                    const fechaAjustada = startOfDay(
                                      new Date(date),
                                    );
                                    field.onChange(fechaAjustada);
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      height={10}
                                      className="form-control"
                                      style={{ height: 10 }}
                                      {...params}
                                    />
                                  )}
                                />
                              </LocalizationProvider>
                            )}
                          />
                          <p className="text-danger mt-3 mb-0">
                            {errors?.fechaTermino?.message}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <div className="form-group">
                          <label className="fw-bold">Hora inicio</label>
                          <Controller
                            control={control}
                            name="horaInicio"
                            rules={{
                              required: "La hora es requerida",
                              validate: (value) => {
                                if (!value) return "La hora es obligatoria";
                                if (!dayjs(value).isValid())
                                  return "Hora inválida";
                                return true;
                              },
                            }}
                            render={({ field }) => (
                              <LocalizationProvider
                                dateAdapter={AdapterDateFns}
                              >
                                <TimePicker
                                  value={field.value ?? null}
                                  label={" "}
                                  onChange={(e) =>
                                    field.onChange(
                                      moment(e).format("yyyy-MM-DD HH:mm:ss"),
                                    )
                                  }
                                  renderInput={(params) => (
                                    <TextField
                                      height={10}
                                      className="form-control"
                                      style={{ height: 10 }}
                                      {...params}
                                    />
                                  )}
                                />
                              </LocalizationProvider>
                            )}
                          />
                          <p className="text-danger mt-3 mb-0">
                            {errors?.horaInicio?.message}
                          </p>
                        </div>
                      </div>
                      <div className="col">
                        <div className="form-group">
                          <label className="fw-bold">Hora Término</label>
                          <Controller
                            control={control}
                            name="horaTermino"
                            rules={{
                              required: "La hora es requerida",
                              validate: (value) => {
                                if (!value) return "La hora es obligatoria";
                                if (!dayjs(value).isValid())
                                  return "Hora inválida";
                                return true;
                              },
                            }}
                            render={({ field }) => (
                              <LocalizationProvider
                                dateAdapter={AdapterDateFns}
                              >
                                <TimePicker
                                  value={field.value ?? null}
                                  label={" "}
                                  onChange={(e) => {
                                    field.onChange(
                                      moment(e).format("yyyy-MM-DD HH:mm:ss"),
                                    );
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      height={10}
                                      className="form-control"
                                      style={{ height: 10 }}
                                      {...params}
                                    />
                                  )}
                                />
                              </LocalizationProvider>
                            )}
                          />
                          <p className="text-danger mt-3 mb-0">
                            {errors?.horaTermino?.message}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <div className="form-group">
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Controller
                                  name="diaCompleto"
                                  control={control}
                                  defaultValue={false}
                                  render={({ field }) => (
                                    <Checkbox
                                      disabled
                                      checked={!!field.value}
                                      onChange={(e) =>
                                        field.onChange(e.target.checked)
                                      }
                                    />
                                  )}
                                />
                              }
                              label="Día Completo"
                            />
                          </FormGroup>
                        </div>
                      </div>
                      <div className="col">
                        <div className="form-group">
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  {...register("recurrencia.recurrente")}
                                />
                              }
                              label="Permiso Recurrente"
                            />
                          </FormGroup>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="row border me-1 ms-1">
                        <div className="col-3">
                          <div className="form-group">
                            <FormGroup>
                              <FormControlLabel
                                sx={{
                                  "& .MuiTypography-root": {
                                    fontSize: { lg: 14, md: 12, xs: 11 },
                                  },
                                }}
                                control={
                                  <Checkbox
                                    disabled={!checkedRecurrente}
                                    value={watch("recurrencia.l")}
                                    checked={watch("recurrencia.l")}
                                    onChange={(e) => {
                                      const isChecked = e.target.checked;
                                      setValue(`recurrencia.l`, isChecked);
                                    }}
                                  />
                                }
                                label="Lunes"
                              />
                            </FormGroup>
                          </div>
                        </div>
                        <div className="col">
                          <div className="form-group">
                            <FormGroup>
                              <FormControlLabel
                                sx={{
                                  "& .MuiTypography-root": {
                                    fontSize: { lg: 14, md: 12, xs: 11 },
                                  },
                                }}
                                control={
                                  <Checkbox
                                    disabled={!checkedRecurrente}
                                    value={watch("recurrencia.m")}
                                    checked={watch("recurrencia.m")}
                                    onChange={(e) => {
                                      const isChecked = e.target.checked;
                                      setValue(`recurrencia.m`, isChecked);
                                    }}
                                  />
                                }
                                label="Martes"
                              />
                            </FormGroup>
                          </div>
                        </div>
                        <div className="col">
                          <div className="form-group">
                            <FormGroup>
                              <FormControlLabel
                                sx={{
                                  "& .MuiTypography-root": {
                                    fontSize: { lg: 14, md: 12, xs: 11 },
                                  },
                                }}
                                control={
                                  <Checkbox
                                    disabled={!checkedRecurrente}
                                    value={watch("recurrencia.x")}
                                    checked={watch("recurrencia.x")}
                                    onChange={(e) => {
                                      const isChecked = e.target.checked;
                                      setValue(`recurrencia.x`, isChecked);
                                    }}
                                  />
                                }
                                label="Miércoles"
                              />
                            </FormGroup>
                          </div>
                        </div>
                        <div className="col">
                          <div className="form-group">
                            <FormGroup>
                              <FormControlLabel
                                sx={{
                                  "& .MuiTypography-root": {
                                    fontSize: { lg: 14, md: 12, xs: 11 },
                                  },
                                }}
                                control={
                                  <Checkbox
                                    disabled={!checkedRecurrente}
                                    value={watch("recurrencia.j")}
                                    checked={watch("recurrencia.j")}
                                    onChange={(e) => {
                                      const isChecked = e.target.checked;
                                      setValue(`recurrencia.j`, isChecked);
                                    }}
                                  />
                                }
                                label="Jueves"
                              />
                            </FormGroup>
                          </div>
                        </div>
                        <div className="col">
                          <div className="form-group">
                            <FormGroup>
                              <FormControlLabel
                                sx={{
                                  "& .MuiTypography-root": {
                                    fontSize: { lg: 14, md: 12, xs: 11 },
                                  },
                                }}
                                control={
                                  <Checkbox
                                    disabled={!checkedRecurrente}
                                    value={watch("recurrencia.v")}
                                    checked={watch("recurrencia.v")}
                                    onChange={(e) => {
                                      const isChecked = e.target.checked;
                                      setValue(`recurrencia.v`, isChecked);
                                    }}
                                  />
                                }
                                label="Viernes"
                              />
                            </FormGroup>
                          </div>
                        </div>
                        <div className="col">
                          <div className="form-group">
                            <FormGroup>
                              <FormControlLabel
                                sx={{
                                  "& .MuiTypography-root": {
                                    fontSize: { lg: 14, md: 12, xs: 11 },
                                  },
                                }}
                                control={
                                  <Checkbox
                                    disabled={!checkedRecurrente}
                                    value={watch("recurrencia.s")}
                                    checked={watch("recurrencia.s")}
                                    onChange={(e) => {
                                      const isChecked = e.target.checked;
                                      setValue(`recurrencia.s`, isChecked);
                                    }}
                                  />
                                }
                                label="Sábado"
                              />
                            </FormGroup>
                          </div>
                        </div>
                        <div className="col">
                          <div className="form-group">
                            <FormGroup>
                              <FormControlLabel
                                sx={{
                                  "& .MuiTypography-root": {
                                    fontSize: { lg: 14, md: 12, xs: 11 },
                                  },
                                }}
                                control={
                                  <Checkbox
                                    disabled={!checkedRecurrente}
                                    value={watch("recurrencia.d")}
                                    checked={watch("recurrencia.d")}
                                    onChange={(e) => {
                                      const isChecked = e.target.checked;
                                      setValue(`recurrencia.d`, isChecked);
                                    }}
                                  />
                                }
                                label="Domingo"
                              />
                            </FormGroup>
                          </div>
                        </div>
                        <div className="col">
                          <div className="form-group" hidden>
                            <FormGroup>
                              <FormControlLabel
                                control={<Checkbox />}
                                label="Domingo"
                              />
                            </FormGroup>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="form-group">
                      <label className="fw-bold">Comentario</label>

                      <textarea
                        className="form-control"
                        {...register("justificacion")}
                        rows={2}
                      ></textarea>
                    </div>

                    <div className="d-flex justify-content-center mt-3">
                      <button
                        id="btn-guardar"
                        type="submit"
                        className="btn btn-primary-mem me-3"
                      >
                        <SaveIcon sx={{ marginTop: -0.5, marginRight: 0.5 }} />{" "}
                        Guardar
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </Stack>
          </Paper>
        </Stack>
      </Stack>

      <Loading open={isLoading} />
    </Encabezado>
  );
};
